import React, { useState } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { Helmet } from "react-helmet";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import NavItem from "@ats/src/components/shared/NavItem";
import UnsavedChangesGuard from "@ats/src/components/shared/UnsavedChangesGuard";
import LoadingIndicator from "@ats/src/components/shared/LoadingIndicator";

import { useAuthorization } from "@ats/src/components/shared/AuthorizationManager";
import { useCurrentSession } from "@ats/src/context/CurrentSessionContext";

import OrganizationAiBilling from "../OrganizationAiBilling";
import OrganizationAiUsage from "../OrganizationAiUsage";
import OrganizationAiSettings from "../OrganizationAiSettings";

function AccountPlatoAiContainer(props: any) {
  const { match } = props;
  const [isDirty, setIsDirty] = useState(false);

  const isAuthorized = useAuthorization();
  const authorized = isAuthorized({ adminOnly: true });

  const { currentOrganization } = useCurrentSession();

  if (!authorized) return null;
  if (currentOrganization == undefined) return <LoadingIndicator label="Loading..." />;

  return (
    <>
      <Helmet title="Plato AI" />
      <Styled.Container>
        <Styled.Sidebar>
          <NavItem to={`${match.url}/billing`} label="Billing" chevron />
          <NavItem to={`${match.url}/usage`} label="Usage" chevron />
          <NavItem to={`${match.url}/settings`} label="Settings" chevron />
        </Styled.Sidebar>

        <UnsavedChangesGuard
          hasUnsavedChanges={isDirty}
          navigate={(pathname) => {
            setIsDirty(false);
            props.history.push(pathname);
          }}
        />

        <Styled.Content>
          <Switch>
            <Route
              path={`${match.path}/billing`}
              render={(renderProps) => (
                <OrganizationAiBilling
                  {...props}
                  {...renderProps}
                  currentOrganization={currentOrganization}
                  setIsDirty={setIsDirty}
                />
              )}
            />
            <Route
              path={`${match.path}/usage`}
              render={(renderProps) => (
                <OrganizationAiUsage
                  {...props}
                  {...renderProps}
                  currentOrganization={currentOrganization}
                  setIsDirty={setIsDirty}
                />
              )}
            />
            <Route
              path={`${match.path}/settings`}
              render={(renderProps) => (
                <OrganizationAiSettings
                  {...props}
                  {...renderProps}
                  currentOrganization={currentOrganization}
                  setIsDirty={setIsDirty}
                />
              )}
            />
            <Redirect to={`${match.url}/billing`} />
          </Switch>
        </Styled.Content>
      </Styled.Container>
    </>
  );
}

export default AccountPlatoAiContainer;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Container = styled.div`
  label: AccountPlatoAiContainer;
  display: flex;
  height: 100%;
`;

Styled.Sidebar = styled.div((props: any) => {
  const t: any = props.theme;
  return css`
    label: AccountPlatoAiContainer_Sidebar;
    color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
    padding-top: 0.375rem;
    border-right: 1px solid ${t.dark ? t.color.gray[800] : t.color.gray[200]};
    flex-shrink: 0;
    width: 40vw;

    ${t.mq["lg"]} {
      width: 33.333%;
      flex-shrink: 1;
    }
  `;
});

Styled.Content = styled.div((props: any) => {
  const t: any = props.theme;
  return css`
    label: AccountPlatoAiContainer_Content;
    height: 100%;
    overflow-y: auto;
    position: relative;
    width: 100vw;
    flex-shrink: 0;

    ${t.mq["lg"]} {
      width: 66.666%;
      flex-shrink: 1;
    }
  `;
});
